import { render, staticRenderFns } from "./Recurring-Detail.vue?vue&type=template&id=c256a4f4"
import script from "./Recurring-Detail.vue?vue&type=script&lang=js"
export * from "./Recurring-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports